import { cn } from '@/utils/cn'
import type { FinanceRequestClientKind } from '@/components/Financeiro/financeQueueHelpers'

const CLIENT_KIND_BADGE: Record<
  FinanceRequestClientKind,
  { label: string; className: string } | null
> = {
  cliente: null,
  assunto: {
    label: 'Assunto',
    className: 'border-violet-500/20 bg-violet-500/10 text-violet-400',
  },
  interno: {
    label: 'Interno',
    className: 'border-slate-500/20 bg-slate-500/10 text-slate-400',
  },
}

export function FinanceRequestClientKindBadge({ kind }: { kind: FinanceRequestClientKind }) {
  const badge = CLIENT_KIND_BADGE[kind]
  if (!badge) return null

  return (
    <span
      className={cn(
        'inline-flex shrink-0 rounded-md border px-1.5 py-0.5 text-[9px] font-black uppercase',
        badge.className,
      )}
    >
      {badge.label}
    </span>
  )
}
